import { Typography } from '@mui/material';

export default function SubTitle({ text }) {
  return (
    <Typography
      sx={{
        fontSize: '16px', color: 'black', fontWeight: 'bold', marginTop: 'auto', marginBottom: 'auto',
      }}
    >
      {text}
    </Typography>
  );
}
